import { Suspense, lazy } from 'react';
import { Outlet } from 'react-router-dom';

import { GuestGuard } from 'src/auth/guard';
import { SplashScreen } from 'src/components/loading-screen';

import { paths } from '../paths';

// JWT
const Login = lazy(() => import('../../modules/auth/login/login'));
const ChangePassword = lazy(() => import('../../modules/auth/change-password/change-password'));

const authJwt = {
  element: (
    <GuestGuard>
      <Suspense fallback={<SplashScreen />}>
        <Outlet />
      </Suspense>
    </GuestGuard>
  ),
  children: [
    {
      path: paths.auth.login,
      element: (
        <Suspense fallback={<SplashScreen />}>
          <Login />
        </Suspense>
      ),
    },
    {
      path: `${paths.auth.changePassword}/:token`,
      element: (
        <Suspense fallback={<SplashScreen />}>
          <ChangePassword />
        </Suspense>
      ),
    },
  ],
};

export const authRoutes = [
  {
    path: paths.auth.root,
    children: [authJwt],
  },
];
